// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { orderTotalDisplaySharedStyles } from "@steiner/App/SharedStyles/OrderTotalDisplaySharedStyles";
import { cartTotalDisplayStyles } from "@steiner/Overrides/Components/CartTotalDisplay";
import { color } from "@steiner/XDL/Utilities";
import { css } from "styled-components";

cartTotalDisplayStyles.container = {
    gap: 12,
    css: css`
        padding: 0;
    `,
};

cartTotalDisplayStyles.orderSummaryGridItem = {
    ...orderTotalDisplaySharedStyles.orderSummaryGridItem,
};

cartTotalDisplayStyles.orderSummaryLabel = {
    ...orderTotalDisplaySharedStyles.titleText,
};

cartTotalDisplayStyles.promotionLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.discountsLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.shippingAndHandlingLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.taxLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.totalLabel = {
    ...orderTotalDisplaySharedStyles.totalLabel,
};

cartTotalDisplayStyles.labelGridItem = {
    ...orderTotalDisplaySharedStyles.labelGridItem,
};

cartTotalDisplayStyles.subtotalLabel = {
    ...orderTotalDisplaySharedStyles.label,
};

cartTotalDisplayStyles.subtotalValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.totalValue = {
    ...orderTotalDisplaySharedStyles.totalValue,
};

cartTotalDisplayStyles.valueGridItem = {
    ...orderTotalDisplaySharedStyles.valueGridItem,
};

cartTotalDisplayStyles.styledHrGridItem = {
    ...orderTotalDisplaySharedStyles.styledHrGridItem,
};

cartTotalDisplayStyles.promotionValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.shippingAndHandlingValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.taxValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.discountsValue = {
    ...orderTotalDisplaySharedStyles.value,
};

cartTotalDisplayStyles.styledBoxContainer = {
    css: css`
        background-color: ${color("common.ui14")};
    `,
};
    